import { useState } from 'react';
import emailjs from '@emailjs/browser';

const CONTACT_EMAIL = 'healthiersmileinitiative@gmail.com';
const CONTACT_PHONE = '+232 78 036 464 / +232 78 656 579';
const CONTACT_ADDRESS = '#8 Janet  Samking  Drive, Reservation opposite Bo City Council';
const MAP_EMBED_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12697.123456789!2d-11.738!3d7.964!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0:0x0!2zN8KwNTcnNTIuMCJOIDExwrA0NCc1NS4wIlc!5e0!3m2!1sen!2ssl!4v1710000000000!5m2!1sen!2ssl';

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState<{ show: boolean; text: string; type: 'success' | 'danger' }>({ show: false, text: '', type: 'success' });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    emailjs
      .send(
        import.meta.env.VITE_APP_EMAILJS_SERVICE_ID,
        import.meta.env.VITE_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: form.name,
          to_name: 'Healthier Smile Initiatives',
          from_email: form.email,
          to_email: CONTACT_EMAIL,
          message: form.message,
          name: form.name
        },
        import.meta.env.VITE_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          setLoading(false);
          setAlert({ show: true, text: 'Thank you for your message 😃', type: 'success' });
          setForm({ name: '', email: '', message: '' });
          setTimeout(() => setAlert({ show: false, text: '', type: 'success' }), 3000);
        },
        () => {
          setLoading(false);
          setAlert({ show: true, text: "We didn't receive your message 😢", type: 'danger' });
        }
      );
  };

  return (
    <div className="max-w-4xl mx-auto py-10 px-4">
      <h1 className="text-3xl font-bold text-teal-700 mb-2 text-center">Contact Us</h1>
      <p className="text-center text-stone-600 mb-2">We're here to help and answer any questions you might have.</p>
      
      <div className="grid md:grid-cols-2 gap-8">
        {/* Contact Info */}
        <div className="flex flex-col gap-6 bg-white rounded-2xl shadow-lg border border-stone-200 p-6 min-h-[420px] md:min-h-[420px] h-full justify-between">
          <div>
          <h2 className="text-xl font-semibold text-teal-800 mb-1 ">Get in Touch</h2>
            <p className=" text-stone-600 mb-8">Have questions about our services? Reach out to us using any of the following methods.</p>
      
            <h2 className="text-xl font-semibold text-teal-800 mb-2">Contact Information</h2>
            <div className="text-stone-700 space-y-2">
              <div><span className="font-medium">Email:</span> <a href={`mailto:${CONTACT_EMAIL}`} className="text-teal-700 hover:underline">{CONTACT_EMAIL}</a></div>
              <div><span className="font-medium">Phone:</span> <a href={`tel:${CONTACT_PHONE}`} className="text-teal-700 hover:underline">{CONTACT_PHONE}</a></div>
              <div><span className="font-medium">Address:</span> {CONTACT_ADDRESS}</div>
            </div>
          </div>
        </div>
        {/* Contact Form */}
        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg border border-stone-200 p-8 flex flex-col gap-4 min-h-[420px] md:min-h-[420px] h-full justify-between">
          <div>
            <h2 className="text-xl font-semibold text-teal-800 mb-2">Send Us a Message</h2>
            {alert.show && (
              <div className={`rounded px-4 py-3 mb-2 text-sm ${alert.type === 'success' ? 'bg-teal-100 text-teal-800' : 'bg-red-100 text-red-700'}`}>{alert.text}</div>
            )}
            <div>
              <label htmlFor="name" className="block text-stone-700 font-medium mb-1">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                className="w-full border border-stone-300 rounded px-4 py-2 focus:ring-teal-500 focus:border-teal-500"
                disabled={loading}
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-stone-700 font-medium mb-1">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full border border-stone-300 rounded px-4 py-2 focus:ring-teal-500 focus:border-teal-500"
                disabled={loading}
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-stone-700 font-medium mb-1">Message</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                rows={5}
                className="w-full border border-stone-300 rounded px-4 py-2 focus:ring-teal-500 focus:border-teal-500"
                disabled={loading}
              ></textarea>
            </div>
          </div>
          <button
            type="submit"
            className="mt-2 bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors flex items-center justify-center"
            disabled={loading}
          >
            {loading && (
              <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
              </svg>
            )}
            {loading ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
      {/* Full-width Map Section */}
      <div className="mt-10 rounded-2xl overflow-hidden shadow-lg border border-stone-200">
        <iframe
          src={MAP_EMBED_URL}
          width="100%"
          height="300"
          style={{ border: 0 }}
          allowFullScreen={true}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Our Location"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactPage; 